const choices = {
    important: 'Oui, je vais regarder tous les jours le montant',
    moderate: 'Oui, mais je suis conscient que c\'est un placement moyen/long terme',
    none: 'Non c\'est un placement moyen/long terme',
};

export default choices;
